export default "__VITE_ASSET__BdvXHWNa__"